'use client';

import { useNotifications } from '@/shared/context/notifications-context';
import { Information } from 'ui';

import styles from './NotificationsArea.module.scss';

export function NotificationsArea() {
	const { notifications } = useNotifications();

	if (!Object.values(notifications).length) return null;

	return (
		<div className={styles.NotificationsArea__Wrapper}>
			<div className={styles.NotificationsArea__Items}>
				{Object.values(notifications).map((notification, index) => (
					<div
						key={notification.id}
						className={`${styles.NotificationsArea__Item} ${styles['fade-in']}`}
					>
						<Information type={notification.type}>{notification.message}</Information>
					</div>
				))}
			</div>
		</div>
	);
}
